import Worker from '@wmfe/mach-pro-worker';

export const uploadShoppingCartInfo = (params, repeat = false) => {
  const Network = Mach.requireModule('Network');
  Network.request(params, (res) => {
    const error = res?.error;
    const { code } = res?.data || {};
    if ((error || code !== 0) && !repeat) {
      uploadShoppingCartInfo(params, true);
    }
  });
};
